import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { ApplicationErrorOptions } from '../../../types';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { FetchAssetParams } from '../types';
import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';

export interface TenantModel {
  tenantActionStart: Action<TenantModel, void>;
  tenantFailure: Action<TenantModel, ApplicationErrorOptions>;
  lastAction?: number;
  tenants: Record<string, PartnerTenant>;
  fetchTenants: Thunk<TenantModel, FetchAssetParams | undefined, Injections, TenantModel, Promise<PartnerTenant[]>>;
  setTenants: Action<TenantModel, PartnerTenant[]>;
  setTenantById: Action<TenantModel, PartnerTenant>;
  globallySelectedTenant?: string;
  setGloballySelectedTenant: Action<TenantModel, string>;
}

export const tenantModel: TenantModel = {
  tenants: {},
  tenantActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  tenantFailure: action((state, error) => {
    console.error(error);
  }),
  fetchTenants: thunk(async (actions, payload, { getState, injections }) => {
    try {
      actions.tenantActionStart();
      const tenants = await injections.assetService.fetchTenants(payload);
      actions.setTenants(tenants);
      return tenants;
    } catch (error: any) {
      actions.tenantFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching tenant from the server.',
        asNotification: true,
      });
      return [];
    }
  }),
  setTenants: action((state, payload) => {
    state.tenants = payload.reduce<Record<string, PartnerTenant>>((prev, curr) => {
      prev[curr.tenantId!] = curr;
      return prev;
    }, {});
  }),
  setGloballySelectedTenant: action((state, payload) => {
    state.globallySelectedTenant = payload;
  }),
  setTenantById: action((state, payload) => {
    const { tenantId } = payload;
    if (state.tenants[tenantId!]) {
      state.tenants[tenantId!] = payload;
    }
  }),
};
